var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCertificates = function SvgCertificates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.121 1.781c-1.06 0-1.933.873-1.933 1.934v4.173h17.1V6.056a1.841 1.841 0 0 0-1.833-1.832H9.483L8.51 2.492a1.398 1.398 0 0 0-1.215-.71H3.12ZM1.188 9.11v6.616c0 1.06.872 1.934 1.933 1.934h13.233c1.06 0 1.934-.873 1.934-1.934V9.11h-17.1Z",
    fill: "currentColor"
  })));
};
export default SvgCertificates;